module.exports = __webpack_public_path__ + "img/karen.76825c60.jpg";